<script setup lang="ts">
withDefaults(
  defineProps<{
    title?: string
    subtitle?: string
    badge?: string
  }>(),
  {
    title: '工具类',
    subtitle: '按能力分组收纳不同工具卡片',
    badge: '',
  },
)
</script>

<template>
  <details class="panel-section" open>
    <summary class="panel-section-summary">
      <span class="summary-main">
        <span class="panel-section-title">{{ title }}</span>
        <span class="panel-section-subtitle">{{ subtitle }}</span>
      </span>
      <span class="summary-side">
        <span v-if="badge" class="summary-count">{{ badge }}</span>
        <span class="summary-chevron" aria-hidden="true">›</span>
      </span>
    </summary>

    <div class="panel-section-body stacked-panel-body">
      <slot />
    </div>
  </details>
</template>
